import { getPrecioPorPersona } from './participantes.js';
import { setHoraSeleccionada } from './hora_seleccionada.js';

let select_actividad = null;

const lugares = {
    "Alberca": {
        titulo: "🏊 Piscina Climatizada",
        ubicacion: "Inacua · Málaga",
        hora: "19:00:00",
        horarioTexto: "19:00 – 21:00",
        imagen: "https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?w=800&h=450&fit=crop&q=80",
        resumen: "49 € por persona · Obligatorio 2 participantes. Agua templada todo el año, instalaciones Inacua modernas y sin necesidad de traje de neopreno.",
        notas: [
            `<strong style="color:#b91c1c;">PRECIO:</strong> <strong>49 €</strong> por persona. Obligatorio <strong>2 participantes</strong> por reserva.`,
            `La actividad se realiza en <strong>alberca climatizada</strong>, por lo que no es necesario el uso de Wetsuit.`,
            `No existen cargos adicionales por traslados y logística de equipo. El uso de las instalaciones Inacua ya está incluido.`,
            `Perfecto para primeras experiencias, familias y quienes prefieren un entorno controlado y cómodo.`
        ]
    },

    "La Herradura Almuñecar": {
        titulo: "🌊 La Herradura",
        ubicacion: "Almuñécar · Costa Tropical",
        hora: "14:00:00",
        horarioTexto: "14:00 – 16:00",
        imagen: "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800&h=450&fit=crop&q=80",
        resumen: "Experiencia en mar abierto con aguas cristalinas y fondo rocoso. Perfecto si buscas la emoción real del buceo en el Mediterráneo.",
        notas: [
            `Se agregan <strong>30 €</strong> por gastos de traslados y logística de equipo.`,
            `La renta del <strong>wetsuit (traje de neopreno)</strong> tiene un costo de <strong>15 € por participante</strong>.`,
            `El uso del wetsuit es altamente recomendado porque la temperatura del agua del mar suele ser fría durante gran parte del año, lo que ayuda a mantener una temperatura corporal cómoda y disfrutar la experiencia con mayor seguridad.`
        ]
    },

    "Rincon de la Victoria": {
        titulo: "🌊 Rincón de la Victoria",
        ubicacion: "Playa · Costa del Sol",
        hora: "14:00:00",
        horarioTexto: "14:00 – 16:00",
        imagen: "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=800&h=450&fit=crop&q=80",
        resumen: "Buceo costero cerca de Málaga. Arena y fondos accesibles, ideal para una primera inmersión en el mar con total seguridad.",
        notas: [
            `No existen cargos adicionales por traslados y logística de equipo.`,
            `La renta del <strong>wetsuit (traje de neopreno)</strong> tiene un costo de <strong>15 € por participante</strong>.`,
            `El uso del wetsuit es altamente recomendado porque la temperatura del agua del mar suele ser fría durante gran parte del año, lo que ayuda a mantener una temperatura corporal cómoda y disfrutar la experiencia con mayor seguridad.`
        ]
    }
};

/*==========================
    ACTIVIDADES TEMPORALMENTE BLOQUEADAS
==========================*/

const actividadesBloqueadas = [
    "La Herradura Almuñecar",
    "Rincon de la Victoria"
];

/*==========================
    INICIALIZAR
==========================*/

export function initLugarActividad() {

    actualizarPreciosLugar();

    // Bloquear actividades
    document.querySelectorAll('.actividad-card').forEach(card => {
        const value = card.dataset.actividad;

        if (actividadesBloqueadas.includes(value)) {
            const radio = card.querySelector('input[name="actividad"]');
            if (radio) radio.disabled = true;

            card.classList.add("actividad-bloqueada");

            const mensaje = document.createElement("div");
            mensaje.className = "mensaje-actividad-bloqueada";
            mensaje.innerHTML = `
                🔒 DESHABILITADO
                <span>Hasta temporada de verano 2027</span>
            `;

            const actividadBox = card.querySelector(".actividad-box");
            if (actividadBox) {
                actividadBox.appendChild(mensaje);
            }
        }
    });

    // Botones: Seleccionar y Ver más detalles
    document.querySelectorAll('.actividad-card').forEach(card => {
        const value = card.dataset.actividad;
        const btnSelect = card.querySelector('[data-action="seleccionar"]');
        const btnDetalles = card.querySelector('[data-action="detalles"]');

        if (btnSelect) {
            btnSelect.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                if (actividadesBloqueadas.includes(value)) return;

                seleccionarActividad(value);
            });
        }

        if (btnDetalles) {
            btnDetalles.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                mostrarDetalles(value);
            });
        }
    });
}

/*==========================
    SELECCIONAR ACTIVIDAD
==========================*/

function seleccionarActividad(value) {
    const lugar = lugares[value];
    if (!lugar) return;

    // Marcar radio
    document.querySelectorAll('input[name="actividad"]').forEach(r => {
        r.checked = (r.value === value);
    });

    // Estado visual de tarjetas y botones
    document.querySelectorAll('.actividad-card').forEach(card => {
        const esEsta = card.dataset.actividad === value;
        card.classList.toggle('seleccionada', esEsta);

        const btn = card.querySelector('.btn-seleccionar');
        if (btn) {
            if (esEsta) {
                btn.textContent = '✓ Seleccionado';
                btn.classList.add('seleccionado');
            } else {
                btn.textContent = 'Seleccionar';
                btn.classList.remove('seleccionado');
            }
        }
    });

    // Horario intrínseco a la actividad
    if (lugar.hora) {
        setHoraSeleccionada(lugar.hora);
    }

    // Resumen breve debajo (info_lugar)
    const info = document.getElementById("info_lugar");
    if (info) {
        info.innerHTML = `
            <h3 class="font-bold text-lg mb-2">${lugar.titulo}</h3>
            <p class="text-sm text-slate-600 mb-1">${lugar.ubicacion}</p>
            <p class="text-sm font-semibold text-sky-700 mb-3">🕐 Horario: ${lugar.horarioTexto || ''}</p>
            <p class="text-sm text-slate-700">${lugar.resumen}</p>
            <p class="text-xs text-slate-500 mt-3">Puedes ver todos los detalles con el botón «Ver más detalles».</p>
        `;
        info.classList.remove("hidden");
    }

    setActividadSeleccionada(value);
    if (typeof window.updateResumenSeleccion === 'function') {
        window.updateResumenSeleccion();
    }
}

/*==========================
    VER MÁS DETALLES (modal)
==========================*/

function mostrarDetalles(value) {
    const lugar = lugares[value];
    if (!lugar) return;

    // Cerrar modal previo
    const old = document.getElementById("detalleActividadOverlay");
    if (old) old.remove();

    if (!document.getElementById("detalleActividadStyle")) {
        const style = document.createElement("style");
        style.id = "detalleActividadStyle";
        style.textContent = `
            #detalleActividadOverlay {
                position: fixed; inset: 0;
                background: rgba(0,0,0,.5);
                backdrop-filter: blur(8px);
                display: flex; align-items: center; justify-content: center;
                z-index: 2147483646;
                padding: 16px;
                animation: fadeIn .2s ease;
            }
            #detalleActividadCard {
                background: #fff;
                width: 100%; max-width: 520px;
                max-height: 90vh;
                overflow-y: auto;
                border-radius: 20px;
                box-shadow: 0 25px 60px rgba(0,0,0,.25);
                animation: slideUp .25s ease;
            }
            #detalleActividadCard img {
                width: 100%; height: 200px; object-fit: cover;
                border-radius: 20px 20px 0 0;
            }
            #detalleActividadCard .detalle-body {
                padding: 22px 22px 18px;
            }
            #detalleActividadCard h2 {
                margin: 0 0 4px; font-size: 22px; font-weight: 800; color: #0f172a;
            }
            #detalleActividadCard .detalle-ubicacion {
                color: #0284c7; font-weight: 600; font-size: 14px; margin-bottom: 12px;
            }
            #detalleActividadCard .detalle-resumen {
                color: #475569; font-size: 15px; line-height: 1.5; margin-bottom: 16px;
            }
            #detalleActividadCard .detalle-nota {
                border-left: 4px solid #f59e0b;
                background: #fffbeb;
                padding: 12px 14px;
                border-radius: 0 12px 12px 0;
                margin-bottom: 10px;
                font-size: 14px;
                color: #78350f;
                line-height: 1.45;
            }
            #detalleActividadCard .detalle-actions {
                display: flex; gap: 10px; margin-top: 18px;
            }
            #detalleActividadCard .detalle-actions button {
                flex: 1; padding: 12px; border-radius: 12px; font-weight: 700;
                font-size: 15px; cursor: pointer; border: none;
            }
            #detalleActividadCard .btn-cerrar-detalle {
                background: #e2e8f0; color: #334155;
            }
            #detalleActividadCard .btn-elegir-detalle {
                background: linear-gradient(180deg, #0ea5e9, #0284c7); color: #fff;
            }
            #detalleActividadCard .detalle-close-x {
                position: absolute; top: 12px; right: 12px;
                width: 34px; height: 34px; border-radius: 50%;
                background: rgba(0,0,0,.45); color: #fff;
                display: flex; align-items: center; justify-content: center;
                cursor: pointer; font-size: 18px; border: none;
            }
        `;
        document.head.appendChild(style);
    }

    const bloqueada = actividadesBloqueadas.includes(value);

    const overlay = document.createElement("div");
    overlay.id = "detalleActividadOverlay";

    const notasHtml = lugar.notas.map(n => `<div class="detalle-nota">⚠️ ${n}</div>`).join("");

    overlay.innerHTML = `
        <div id="detalleActividadCard" style="position:relative;">
            <button type="button" class="detalle-close-x" aria-label="Cerrar">✕</button>
            <img src="${lugar.imagen}" alt="${lugar.titulo}">
            <div class="detalle-body">
                <h2>${lugar.titulo}</h2>
                <div class="detalle-ubicacion">${lugar.ubicacion}</div>
                <p class="detalle-ubicacion" style="color:#0f172a;">🕐 Horario: ${lugar.horarioTexto || ''}</p>
                <p class="detalle-resumen">${lugar.resumen}</p>
                ${notasHtml}
                <div class="detalle-actions">
                    <button type="button" class="btn-cerrar-detalle">Cerrar</button>
                    ${bloqueada
                        ? `<button type="button" class="btn-elegir-detalle" disabled style="opacity:.5;cursor:not-allowed;">No disponible</button>`
                        : `<button type="button" class="btn-elegir-detalle">Seleccionar este lugar</button>`
                    }
                </div>
            </div>
        </div>
    `;

    document.body.appendChild(overlay);

    const cerrar = () => overlay.remove();

    overlay.querySelector(".detalle-close-x").onclick = cerrar;
    overlay.querySelector(".btn-cerrar-detalle").onclick = cerrar;
    overlay.addEventListener("click", (e) => {
        if (e.target === overlay) cerrar();
    });

    const btnElegir = overlay.querySelector(".btn-elegir-detalle");
    if (btnElegir && !bloqueada) {
        btnElegir.onclick = () => {
            cerrar();
            seleccionarActividad(value);
        };
    }
}

/*==========================
    ACTUALIZAR PRECIOS
==========================*/

export function actualizarPreciosLugar() {
    const precio = getPrecioPorPersona();

    document.querySelectorAll("#lugar_actividad .actividad-card").forEach(card => {
        const el = card.querySelector(".precio");
        if (!el) return;

        // Piscina: 49€ por persona, obligatorio 2 participantes
        if (el.dataset.precioTipo === "oferta-alberca") {
            el.innerHTML = `
                <span class="precio-principal">€49</span>
                <span class="precio-detalle">/persona</span>
                <span class="precio-gratis">2 participantes</span>
            `;
            return;
        }

        el.innerHTML = `€${precio} <span style="font-size:14px;font-weight:500;">/persona</span>`;
    });
}

/*==========================
    GETTERS / SETTERS
==========================*/

export function getActividadSeleccionada() {
    return select_actividad;
}

export function setActividadSeleccionada(actividad) {
    select_actividad = actividad;
}